import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  user: null,
  isInitialised: false,
  isAuthenticated: false,
  errorMsg: '',
  isError: false,
  accessToken: '',
  ssoToken: '',
  is_password_updated: '',
  loader: false
};

export const authSlice = createSlice({
  name: 'auth',
  initialState,
  reducers: {
    setprofile: (state, action) => {
      const { user } = action.payload;
      return { ...state, isAuthenticated: true, user, errorMsg: '', isError: false };
    },
    updateBankingDetails: (state, action) => {
      const { user } = action.payload;
      let obj = {
        ...state,
        ...state.user,
        first_name: user.first_name,
        last_name: user.last_name,
        mobile_number: user.mobile_number,
        bank_name: user.bank_name,
        bank_branch_name: user.bank_branch_name,
        bank_address: user.bank_address,
        bank_account_holder_name: user.bank_account_holder_name,
        bank_account_no: user.bank_account_no,
        bank_ifsc_code: user.bank_ifsc_code,
        gst_number: user.gst_number,
        pan_number: user.pan_number
      };
      return {
        ...state,
        user: obj
      };
    },
    setAccessToken: (state, action) => {
      // state.accessToken = action.payload;
      const { token, ssoToken } = action.payload;
      return { ...state, isAuthenticated: true, accessToken: token, ssoToken: ssoToken };
    },
    setUpdatePassword: (state, action) => {
      // state.accessToken = action.payload;
      const { is_password_updated } = action.payload;
      return { ...state, is_password_updated: is_password_updated };
    },
    setSSOAccessToken: (state, action) => {
      const { token } = action.payload;
      return { ...state, isAuthenticated: true, ssoToken: token };
    },
    setLoader: (state, action) => {
      const { loader, errorMsg } = action.payload;
      return { ...state, loader: loader, errorMsg: errorMsg };
    },
    setUpdateMemberDetails: (state, action) => {
      const { user } = action.payload;
      let obj = {
        ...state,
        ...state.user,
        first_name: user.first_name,
        last_name: user.last_name,
        email_id: user?.email_id,
        mobile_number: user?.mobile_number
      };
      return {
        ...state,
        user: obj
      };
    },
    setUpdateEmergencyContact: (state, action) => {
      const { user } = action.payload;
      let obj = {
        ...state,
        ...state.user,
        relationship_type: user.relationship_type,
        relative_Name: user.relative_Name,
        emergencY_CONTACT_NO: user?.emergencY_CONTACT_NO,
        emergencY_EmailID: user?.emergencY_EmailID
      };
      return {
        ...state,
        user: obj
      };
    },
    logout: (state) => {
      return { ...state, isAuthenticated: false, accessToken: '', ssoToken: '', user: null };
    }
  }
});

export const {
  setprofile,
  setAccessToken,
  setSSOAccessToken,
  logout,
  updateBankingDetails,
  setLoader,
  setUpdatePassword,
  setUpdateMemberDetails,
  setUpdateEmergencyContact
} = authSlice.actions;

export default authSlice.reducer;
